import { useState } from "react";
import { Box, InputAdornment, IconButton, TextField } from "@mui/material";
import { SettingsSuggestRounded } from "@mui/icons-material";
import TagChip from "./TagChip";
import { Modal } from "../modals";
import ColorPicker from "../ColorPicker";
import { getRandomHexColor } from "../../../utils";

const TagModal = ({
  open,
  setOpen,
  title,
  confirm,
  tagName = "",
  tagColor = "",
}) => {
  const [name, setName] = useState(tagName);
  const [color, setColor] = useState(tagColor || getRandomHexColor());

  const [errorName, setErrorName] = useState("");
  const [errorColor, setErrorColor] = useState("");

  const areValuesValid = () => {
    const errNameNotProvided = !name ? "Name is not provided" : "";
    const errColorNotProvided = !color ? "Color is not provided" : "";

    if (errNameNotProvided || errColorNotProvided) {
      setErrorName(errNameNotProvided);
      setErrorColor(errColorNotProvided);
      return false;
    }

    const errNameTooLong =
      name.length > 50 ? "Name can only be up to 50 characters long" : "";
    const errColorTooLong = color.length > 10 ? "Color is invalid" : "";

    if (errNameTooLong || errColorTooLong) {
      setErrorName(errNameTooLong);
      setErrorColor(errColorTooLong);
      return false;
    }

    return true;
  };

  const handleConfirm = () => {
    if (!areValuesValid()) return;
    confirm(name, color);
  };

  const regenerateColor = () => {
    setColor(getRandomHexColor());
  };

  return (
    <Modal open={open} setOpen={setOpen} title={title} confirm={handleConfirm}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mb: 1,
        }}
      >
        <Box
          sx={{
            my: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <TagChip label={name || "example"} color={color} />
        </Box>
        <TextField
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value.trim())}
          error={!!errorName}
          helperText={errorName}
        />
        <TextField
          label="Color"
          value={color}
          onChange={(e) => setColor(e.target.value.trim())}
          error={!!errorColor}
          helperText={errorColor}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mr: 1,
                  }}
                >
                  <ColorPicker
                    color={color}
                    setColor={setColor}
                    direct={true}
                  />
                  <IconButton onClick={regenerateColor} edge="end">
                    <SettingsSuggestRounded />
                  </IconButton>
                </Box>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Modal>
  );
};

export default TagModal;
